import { OptionTitle } from "./OptionTitle"
import { HelpfulOption } from "../types/helpfulOption"

const mostHelpfulOptions = {
  [HelpfulOption.HELP_FINDING_PROVIDER]: { defaultMessage: "Finding or choosing a provider" },
  [HelpfulOption.CHAT_FERTILITY]: { defaultMessage: "Chat about menstrual cycles and evaluating fertility" },
  [HelpfulOption.CHAT_HEALTH]: { defaultMessage: "Chat about health and wellness-related questions" },
  [HelpfulOption.DOULA_INFO]: { defaultMessage: "Information about birth and postpartum doulas" },
  [HelpfulOption.DOULA_POSTPARTUM_INFO]: { defaultMessage: "Information about postpartum doulas" },
  [HelpfulOption.DOULA_GENERAL_INFO]: { defaultMessage: "Information about doulas" },
  [HelpfulOption.EMOTIONAL_SUPPORT]: { defaultMessage: "Getting emotional support" },
  [HelpfulOption.PRENATAL_YOGA]: { defaultMessage: "Prenatal yoga class" },
  [HelpfulOption.LEARN_MILK_SHIPPING]: { defaultMessage: "Learn about milk shipping" },
  [HelpfulOption.SUPPORT_LACTATION_INFANT_FEEDING]: { defaultMessage: "Infant feeding" },
  [HelpfulOption.LGBTQ_FAMILY]: { defaultMessage: "LGBTQ+ family-forming guidance" },
  [HelpfulOption.FINANCE_INFO]: { defaultMessage: "Financial information, reimbursement, benefit advice" },
  [HelpfulOption.FINANCIAL_CONCERNS_JOURNEY_COST]: {
    defaultMessage: "Addressing financial concerns related to the cost of this journey"
  },
  [HelpfulOption.NOT_SURE]: { defaultMessage: "I’m not sure" },
  [HelpfulOption.PRENATAL_HEALTH_WELLNESS]: { defaultMessage: "Prenatal health and wellness" },
  [HelpfulOption.FETAL_DEVELOPMENT]: { defaultMessage: "Fetal development" },
  [HelpfulOption.HIGH_RISK_PREGNANCY]: { defaultMessage: "High-risk pregnancy" },
  [HelpfulOption.EARLY_BIRTH_PLANNING]: { defaultMessage: "Early birth planning considerations" },
  [HelpfulOption.BIRTH_OPTIONS_SETTINGS]: { defaultMessage: "Birth options and settings" },
  [HelpfulOption.BIRTH_PLAN_RESOURCES]: { defaultMessage: "Birth plan resources" },
  [HelpfulOption.PREGNANCY_SUPPORT_TEAM]: { defaultMessage: "Pregnancy and birth support team" },
  [HelpfulOption.PHYSICAL_PREPARATION]: { defaultMessage: "Physical preparation" },
  [HelpfulOption.EMOTIONAL_PREPARATION]: { defaultMessage: "Emotional preparation" },
  [HelpfulOption.PARENTAL_LEAVE_PLAN]: { defaultMessage: "Parental leave plan" },
  [HelpfulOption.PARENTAL_LEAVE_RETURN_TO_WORK_PLAN]: { defaultMessage: "Parental leave or return to work plan" },
  [HelpfulOption.ADVANCED_MATERNAL_AGE]: { defaultMessage: "Advanced maternal age (AMA)" },
  [HelpfulOption.DIABETES_MANAGEMENT]: { defaultMessage: "Diabetes/gestational diabetes" },
  [HelpfulOption.BLOOD_PRESSURE_MANAGEMENT]: { defaultMessage: "High blood pressure" },
  [HelpfulOption.CHRONIC_CONDITIONS]: { defaultMessage: "Chronic medical conditions" },
  [HelpfulOption.MULTIPLE_FETUSES]: { defaultMessage: "Multiple fetuses" },
  [HelpfulOption.UTERINE_CONDITIONS]: { defaultMessage: "Uterine conditions" },
  [HelpfulOption.HIGH_RISK_PREGNANCY_HISTORY]: { defaultMessage: "History of high-risk pregnancies" },
  [HelpfulOption.PRIOR_COMPLICATED_BIRTH]: { defaultMessage: "Prior complicated birth" },
  [HelpfulOption.FIRST_TRIMESTER_DEVELOPMENT]: { defaultMessage: "1st trimester development stages" },
  [HelpfulOption.GENETIC_SCREENING]: { defaultMessage: "Genetic screening" },
  [HelpfulOption.GENETIC_SCREENING_PRENATAL_TESTING]: { defaultMessage: "Genetic screening and prenatal testing" },
  [HelpfulOption.ULTRASOUND_IMAGING]: { defaultMessage: "Ultrasound imaging" },
  [HelpfulOption.PREGNANCY_RISKS_COMPLICATIONS]: { defaultMessage: "Risks and complications" },
  [HelpfulOption.PREGNANCY_WARNING_SIGNS]: { defaultMessage: "Warning signs" },
  [HelpfulOption.PREGNANCY_EXERCISE]: { defaultMessage: "Exercise" },
  [HelpfulOption.PREGNANCY_DISCOMFORTS]: { defaultMessage: "Nausea and physical discomforts" },
  [HelpfulOption.STRESS_MANAGEMENT]: { defaultMessage: "Stress management" },
  [HelpfulOption.SLEEP_FATIGUE]: { defaultMessage: "Sleep and fatigue" },
  [HelpfulOption.MEDICATION_SUPPLEMENTS]: { defaultMessage: "Medication and supplements" },
  [HelpfulOption.PRENATAL_EDUCATION]: { defaultMessage: "Prenatal education and parenting classes" },
  [HelpfulOption.SECOND_TRIMESTER_DEVELOPMENT]: { defaultMessage: "2nd trimester development stages" },
  [HelpfulOption.FETAL_MOVEMENT]: { defaultMessage: "Fetal movement" },
  [HelpfulOption.BIRTH_PREPARATION]: { defaultMessage: "Birth preparation" },
  [HelpfulOption.VAGINAL_BIRTH_AFTER_CESAREAN]: { defaultMessage: "Vaginal birth after cesarean (VBAC)" },
  [HelpfulOption.SIGNS_OF_LABOR]: { defaultMessage: "Signs of labor" },
  [HelpfulOption.STAGES_OF_LABOR]: { defaultMessage: "Stages of labor" },
  [HelpfulOption.PAIN_MANAGEMENT]: { defaultMessage: "Pain management and coping strategies" },
  [HelpfulOption.POSTPARTUM_PLAN]: { defaultMessage: "Postpartum plan" },
  [HelpfulOption.BREASTFEEDING_INFO]: { defaultMessage: "Lactation" },
  [HelpfulOption.HIGH_BLOOD_PRESSURE_PREECLAMPSIA]: { defaultMessage: "High blood pressure/preeclampsia" },
  [HelpfulOption.BREECH_POSITION]: { defaultMessage: "Breech position" },
  [HelpfulOption.PLANNED_CESAREAN]: { defaultMessage: "Planned cesarean" },
  [HelpfulOption.THIRD_TRIMESTER_DEVELOPMENT]: { defaultMessage: "3rd trimester development stages" },
  [HelpfulOption.POSTPARTUM_PHYSICAL_HEALTH]: { defaultMessage: "Postpartum physical health" },
  [HelpfulOption.POSTPARTUM_MENTAL_HEALTH]: { defaultMessage: "Postpartum emotions and mental health" },
  [HelpfulOption.RETURN_TO_WORK]: { defaultMessage: "Return to work" },
  [HelpfulOption.RETURN_TO_WORK_PLAN]: { defaultMessage: "Return to work plan" },
  [HelpfulOption.EMOTIONAL_CHALLENGES_WORK]: { defaultMessage: "Emotional challenges of returning to work" },
  [HelpfulOption.MANAGER_CONVERSATIONS]: { defaultMessage: "Manager conversations" },
  [HelpfulOption.WORK_LIFE_BALANCE]: { defaultMessage: "Work-life balance" },
  [HelpfulOption.SLEEP_DEPRIVATION_WORK]: { defaultMessage: "Sleep deprivation and returning to work" },
  [HelpfulOption.PUMPING_AT_WORK]: { defaultMessage: "Tips for pumping at work" },
  [HelpfulOption.REMOTE_WORK_NEWBORN]: { defaultMessage: "Remote work and caring for a newborn" },
  [HelpfulOption.LATCH_POSITION]: { defaultMessage: "Latch and position" },
  [HelpfulOption.MILK_SUPPLY]: { defaultMessage: "Milk supply concerns" },
  [HelpfulOption.NIPPLE_SORENESS]: { defaultMessage: "Lactation-related discomfort" },
  [HelpfulOption.MILK_PUMPING_STORAGE]: { defaultMessage: "Milk pumping and storage" },
  [HelpfulOption.INDUCED_LACTATION]: { defaultMessage: "Induced lactation" },
  [HelpfulOption.COMBINATION_FEEDING]: { defaultMessage: "Combination feeding" },
  [HelpfulOption.CESAREAN_RECOVERY_FEEDING]: { defaultMessage: "Cesarean recovery and lactation" },
  [HelpfulOption.NICU_FEEDING]: { defaultMessage: "NICU feeding support" },
  [HelpfulOption.RETURN_TO_WORK_FEEDING]: { defaultMessage: "Return to work feeding support" },
  [HelpfulOption.NEW_PARENT_EMOTIONS]: { defaultMessage: "New parent emotions" },
  [HelpfulOption.PERINATAL_MOOD_DISORDERS]: { defaultMessage: "Perinatal mood and anxiety disorders (PMAD)" },
  [HelpfulOption.TRAUMATIC_BIRTH]: { defaultMessage: "Traumatic or complicated birth" },
  [HelpfulOption.BIRTH_IN_NICU]: { defaultMessage: "Birth in NICU/Special-care nursery" },
  [HelpfulOption.SELF_CARE]: { defaultMessage: "Self-care" },
  [HelpfulOption.FINDING_HELP_SUPPORT]: { defaultMessage: "Finding help and support" },
  [HelpfulOption.POSTPARTUM_WARNING_SIGNS]: { defaultMessage: "Warning signs" },
  [HelpfulOption.VAGINAL_DELIVERY_DISCOMFORT]: { defaultMessage: "Vaginal delivery discomfort" },
  [HelpfulOption.CESAREAN_BIRTH_RECOVERY]: { defaultMessage: "Cesarean birth recovery" },
  [HelpfulOption.POSTPARTUM_CHECKUPS]: { defaultMessage: "Postpartum check-ups" },
  [HelpfulOption.PELVIC_HEALTH]: { defaultMessage: "Pelvic health" },
  [HelpfulOption.SLEEP_FATIGUE_MANAGEMENT]: { defaultMessage: "Sleep and fatigue management" },
  [HelpfulOption.FAMILY_PLANNING]: { defaultMessage: "Family planning and contraception" },
  [HelpfulOption.FERTILITY_BASICS]: { defaultMessage: "Fertility basics" },
  [HelpfulOption.COMMON_FERTILITY_CHALLENGES]: { defaultMessage: "Understanding common fertility challenges" },
  [HelpfulOption.PRE_PREGNANCY_HEALTH]: { defaultMessage: "Optimizing pre-pregnancy health" },
  [HelpfulOption.IMPROVING_METABOLIC_HEALTH]: { defaultMessage: "Improving metabolic health" },
  [HelpfulOption.RELATIONSHIP_SUPPORT]: { defaultMessage: "Co-parenting and relationship support" },
  [HelpfulOption.OVULATION_TRACKING]: { defaultMessage: "Ovulation tracking" },
  [HelpfulOption.HORMONAL_CONTRACEPTION_AND_FERTILITY]: { defaultMessage: "Hormonal contraception and fertility" },
  [HelpfulOption.LGBTQIA_PLUS_SUPPORT]: { defaultMessage: "LGBTQIA+ support" },
  [HelpfulOption.TRANSGENDER_FERTILITY_CONSIDERATIONS]: { defaultMessage: "Transgender fertility considerations" },
  [HelpfulOption.SPERM_HEALTH]: { defaultMessage: "Sperm health" },
  [HelpfulOption.VASECTOMY_REVERSAL]: { defaultMessage: "Vasectomy reversal" },
  [HelpfulOption.POLYCYSTIC_OVARY_SYNDROME_PCOS]: { defaultMessage: "Polycystic ovary syndrome (PCOS)" },
  [HelpfulOption.ENDOMETRIOSIS]: { defaultMessage: "Endometriosis" },
  [HelpfulOption.LOW_OR_HIGH_BMI]: { defaultMessage: "Low or high BMI" },
  [HelpfulOption.UTERINE_DISORDERS]: { defaultMessage: "Uterine disorder(s)" },
  [HelpfulOption.DIMINISHED_OVARIAN_RESERVE]: { defaultMessage: "Diminished ovarian reserve" },
  [HelpfulOption.TUBAL_FACTOR]: { defaultMessage: "Tubal factor" },
  [HelpfulOption.PREGNANCY_LOSS]: { defaultMessage: "Pregnancy loss" },
  [HelpfulOption.RECURRENT_PREGNANCY_LOSS]: { defaultMessage: "Recurrent pregnancy loss" },
  [HelpfulOption.ADVANCED_MATERNAL_AGE_35_PLUS]: { defaultMessage: "Advanced maternal age (35+)" },
  [HelpfulOption.EARLY_MENOPAUSE_OR_PRIMARY_OVARIAN_INSUFFICIENCY]: {
    defaultMessage: "Early menopause or primary ovarian insufficiency"
  },
  [HelpfulOption.UNEXPLAINED_INFERTILITY]: { defaultMessage: "Unexplained infertility" },
  [HelpfulOption.ERECTILE_DYSFUNCTION]: { defaultMessage: "Erectile dysfunction" },
  [HelpfulOption.NUTRITION]: { defaultMessage: "Nutrition" },
  [HelpfulOption.SUPPLEMENTS_FOR_PRE_PREGNANCY]: { defaultMessage: "Supplements for pre-pregnancy" },
  [HelpfulOption.OPTIMIZING_EGG_HEALTH]: { defaultMessage: "Optimizing egg health" },
  [HelpfulOption.OPTIMIZING_SPERM_HEALTH]: { defaultMessage: "Optimizing sperm health" },
  [HelpfulOption.MEDICATION_SAFETY]: { defaultMessage: "Medication safety" },
  [HelpfulOption.GLP1_TRYING_TO_GET_PREGNANT]: { defaultMessage: "GLP-1s and trying to get pregnant" },
  [HelpfulOption.PRE_EXISTING_MEDICAL_CONDITIONS]: { defaultMessage: "Pre-existing medical condition(s)" },
  [HelpfulOption.PRE_EXISTING_MEDICAL_METABOLIC_CONDITIONS]: {
    defaultMessage: "Pre-existing medical or metabolic condition(s)"
  },
  [HelpfulOption.KNOWN_GENETIC_OR_HEREDITARY_CONDITIONS]: {
    defaultMessage: "Known genetic or hereditary condition(s)"
  },
  [HelpfulOption.IMPROVING_FERTILITY_WITHOUT_MEDICAL_INTERVENTIONS]: {
    defaultMessage: "Improving fertility without medical interventions"
  },
  [HelpfulOption.TESTING_AND_CONSULTATIONS]: { defaultMessage: "Testing and consultations" },
  [HelpfulOption.HELP_PREPARING_FOR_AN_APPOINTMENT]: { defaultMessage: "Help preparing for an appointment" },
  [HelpfulOption.INITIAL_CONSULTATIONS]: { defaultMessage: "Initial consultations" },
  [HelpfulOption.FERTILITY_EVALUATION]: { defaultMessage: "Fertility evaluation" },
  [HelpfulOption.OVARIAN_RESERVE_TESTING]: { defaultMessage: "Ovarian reserve testing" },
  [HelpfulOption.SEMEN_ANALYSIS]: { defaultMessage: "Semen analysis" },
  [HelpfulOption.TRANSVAGINAL_ULTRASOUND]: { defaultMessage: "Transvaginal ultrasound" },
  [HelpfulOption.UTERINE_SCREENING]: { defaultMessage: "Uterine screening" },
  [HelpfulOption.GENETIC_CARRIER_SCREENING]: { defaultMessage: "Genetic carrier screening" },
  [HelpfulOption.ASSISTED_REPRODUCTION_BASICS]: { defaultMessage: "Assisted reproduction basics" },
  [HelpfulOption.DONOR_ASSISTANCE]: { defaultMessage: "Learning about donor assistance" },
  [HelpfulOption.UNDERSTANDING_IUI]: { defaultMessage: "Understanding IUI" },
  [HelpfulOption.UNDERSTANDING_IVF]: { defaultMessage: "Understanding IVF" },
  [HelpfulOption.FAITH_INCLUSIVE_CARE]: { defaultMessage: "Faith-inclusive care" },
  [HelpfulOption.SINGLE_INTENDED_PARENT_SUPPORT]: { defaultMessage: "Single intended parent support" },
  [HelpfulOption.MALE_FACTOR_INFERTILITY]: { defaultMessage: "Male factor infertility" },
  [HelpfulOption.DONOR_EGGS]: { defaultMessage: "Donor eggs" },
  [HelpfulOption.DONOR_SPERM]: { defaultMessage: "Donor sperm" },
  [HelpfulOption.GESTATIONAL_SURROGACY_BASICS]: { defaultMessage: "Gestational surrogacy basics" },
  [HelpfulOption.PREPARING_FOR_IUI]: { defaultMessage: "Preparing for IUI" },
  [HelpfulOption.ADMINISTERING_MEDICATION]: { defaultMessage: "Learning to administer medication" },
  [HelpfulOption.POLYCYSTIC_OVARY_SYNDROME]: { defaultMessage: "Polycystic ovary syndrome (PCOS)" },
  [HelpfulOption.FAITH_INCLUSIVE_OPTIONS_FOR_SEMEN_COLLECTION]: {
    defaultMessage: "Understanding faith-inclusive options for semen collection"
  },
  [HelpfulOption.GLP1_FERTILITY_TREATMENTS]: { defaultMessage: "GLP-1s and fertility treatments" },
  [HelpfulOption.PREPARING_FOR_IVF]: { defaultMessage: "Preparing for IVF" },
  [HelpfulOption.EMBRYO_GRADING]: { defaultMessage: "Embryo grading" },
  [HelpfulOption.GENETIC_TESTING_OPTIONS]: { defaultMessage: "Genetic testing options" },
  [HelpfulOption.OVARIAN_STIMULATION]: { defaultMessage: "Ovarian stimulation" },
  [HelpfulOption.EGG_RETRIEVAL]: { defaultMessage: "Egg retrieval" },
  [HelpfulOption.RECIPROCAL_IVF]: { defaultMessage: "Reciprocal IVF" },
  [HelpfulOption.FRESH_VS_FROZEN_EMBRYO_TRANSFER]: { defaultMessage: "Fresh vs. frozen embryo transfers" },
  [HelpfulOption.SINGLE_VS_MULTIPLE_EMBRYO_TRANSFER]: { defaultMessage: "Single vs. multiple embryo transfers" },
  [HelpfulOption.FERTILIZATION_METHODS]: { defaultMessage: "Fertilization methods" },
  [HelpfulOption.MINIMUM_STIMULATION_AND_NATURAL_CYCLES]: {
    defaultMessage: "Minimum stimulation and natural cycles"
  },
  [HelpfulOption.HELP_NAVIGATING_NEXT_STEPS]: { defaultMessage: "Help navigating next steps" },
  [HelpfulOption.EMBRYO_STORAGE_AND_CRYOSHIPPING]: { defaultMessage: "Embryo storage and cryoshipping" },
  [HelpfulOption.FROZEN_EMBRYO_TRANSFERS]: { defaultMessage: "Frozen embryo transfers" },
  [HelpfulOption.PARENT_SELF_CARE]: { defaultMessage: "Parent self care" },
  [HelpfulOption.INFANT_LIFESTYLE]: { defaultMessage: "Infant lifestyle (sleep, crying, etc)" },
  [HelpfulOption.INFANT_HEALTH_NUTRITION_AND_SAFETY]: { defaultMessage: "Infant health, nutrition, and safety" },
  [HelpfulOption.SHIPPING_BREAST_CHEST_MILK]: { defaultMessage: "Shipping milk" },
  [HelpfulOption.INFANT_HEALTH_OR_MEDICAL_CONDITION]: { defaultMessage: "Infant health or medical condition" },
  [HelpfulOption.DEVELOPMENTAL_MILESTONES]: { defaultMessage: "Developmental milestones" },
  [HelpfulOption.SAFETY_CHILDPROOFING]: { defaultMessage: "Safety and childproofing" },
  [HelpfulOption.PREPARING_FORMULA]: { defaultMessage: "Preparing formula" },
  [HelpfulOption.BOTTLE_FEEDING]: { defaultMessage: "Bottle feeding" },
  [HelpfulOption.BABY_LED_WEANING]: { defaultMessage: "Baby-led weaning" },
  [HelpfulOption.INTRODUCING_SOLID_FOOD]: { defaultMessage: "Introducing solid food" },
  [HelpfulOption.BATHING_DIAPERING_SWADDLING]: { defaultMessage: "Bathing, diapering, and swaddling" },
  [HelpfulOption.SAFE_SLEEP_GUIDELINES]: { defaultMessage: "Safe sleep guidelines" },
  [HelpfulOption.COMFORT_TECHNIQUES_CRYING_FUSSINESS]: {
    defaultMessage: "Comfort techniques for crying and fussiness"
  },
  [HelpfulOption.INFANT_SLEEP_SLEEP_TRAINING]: { defaultMessage: "Infant sleep and sleep training" },
  [HelpfulOption.INFANT_BEHAVIORS]: { defaultMessage: "Infant behaviors" },
  [HelpfulOption.POSTPARTUM_HEALTH_NUTRITION_LIFESTYLE]: {
    defaultMessage: "Postpartum health, nutrition, and lifestyle"
  },
  [HelpfulOption.NEW_PARENT_EMOTIONS_MENTAL_HEALTH]: { defaultMessage: "New parent emotions and mental health" },
  [HelpfulOption.PREMATURE_SICK_SPECIAL_NEEDS_INFANT]: { defaultMessage: "Premature, sick, or special needs infant" },
  [HelpfulOption.BREAST_CHESTFEEDING_SUPPORT]: { defaultMessage: "Lactation support" },
  [HelpfulOption.BREAST_CHESTFEEDING_AFTER_RETURNING_TO_WORK]: {
    defaultMessage: "Infant feeding after returning to work"
  },
  [HelpfulOption.FINDING_CHILDCARE]: { defaultMessage: "Finding childcare" },
  [HelpfulOption.CHILD_LIFESTYLE]: { defaultMessage: "Child lifestyle (sleep, crying, etc)" },
  [HelpfulOption.CHILD_HEALTH_NUTRITION_SAFETY]: { defaultMessage: "Child health, nutrition, and safety" },
  [HelpfulOption.CHILDPROOFING]: { defaultMessage: "Childproofing" },
  [HelpfulOption.SCREEN_TIME_INTERNET_SAFETY]: { defaultMessage: "Screen time and internet safety" },
  [HelpfulOption.CHILD_HEALTH_MEDICAL_CONDITION]: { defaultMessage: "Child health or a medical condition" },
  [HelpfulOption.CHOOSY_EATERS]: { defaultMessage: "Choosy eaters" },
  [HelpfulOption.CHILD_BEHAVIOR_CHALLENGES]: { defaultMessage: "Child behavior challenges" },
  [HelpfulOption.TRANSITIONING_CRIB_TO_BED]: { defaultMessage: "Transitioning from crib to bed" },
  [HelpfulOption.POTTY_TRAINING]: { defaultMessage: "Potty training" },
  [HelpfulOption.PREPARING_CHILD_FOR_SIBLING]: { defaultMessage: "Preparing child for a sibling" },
  [HelpfulOption.PARENT_EMOTIONS_MENTAL_HEALTH]: { defaultMessage: "Parent emotions and mental health" },
  [HelpfulOption.PARENTING_CHILD_SPECIAL_NEEDS]: { defaultMessage: "Parenting a child with special needs" },
  [HelpfulOption.BALANCING_PARENTHOOD_CAREER]: { defaultMessage: "Balancing parenthood and career" },
  [HelpfulOption.SLEEP_HABITS_REGRESSION]: { defaultMessage: "Sleep habits and regression" },
  [HelpfulOption.BULLYING_SCHOOL_CONFLICT]: { defaultMessage: "Bullying and school conflict" },
  [HelpfulOption.PHYSICAL_EMOTIONAL_CHANGES_PUBERTY]: { defaultMessage: "Physical and emotional changes of puberty" },
  [HelpfulOption.NUTRITION_CHOOSY_EATERS]: { defaultMessage: "Nutrition for choosy eaters" },
  [HelpfulOption.PHYSICAL_ACTIVITY_EXERCISE]: { defaultMessage: "Physical activity and exercise" },
  [HelpfulOption.RETURNING_TO_WORK_WITH_OLDER_CHILDREN]: { defaultMessage: "Returning to work with older children" },
  [HelpfulOption.EMOTIONS_AROUND_RETURNING_TO_WORK]: { defaultMessage: "Emotions around returning to work" },
  [HelpfulOption.MENOPAUSE_SYMPTOMS]: { defaultMessage: "Menopause symptoms" },
  [HelpfulOption.TREATMENT_OPTIONS]: { defaultMessage: "Treatment options" },
  [HelpfulOption.NUTRITION_WEIGHT_MANAGEMENT_SUPPORT]: { defaultMessage: "Nutrition or weight management support" },
  [HelpfulOption.FERTILITY_PRESERVATION]: { defaultMessage: "Fertility preservation" },
  [HelpfulOption.ASSISTED_REPRODUCTION]: { defaultMessage: "Assisted reproduction" },
  [HelpfulOption.COPING_SYMTOMS_AT_WORK]: { defaultMessage: "Coping with symptoms at work" },
  [HelpfulOption.HORMONE_THERAPY_TREATMENT_OPTIONS]: {
    defaultMessage: "Hormone therapy or other treatment options"
  },
  [HelpfulOption.MEMORY_FOCUS_COGNITIVE_ISSUES]: { defaultMessage: "Memory, focus, and other cognitive issues" },
  [HelpfulOption.LOSS_OF_LIBIDO_SEXUAL_ISSUES]: { defaultMessage: "Loss of libido or other sexual issues" },
  [HelpfulOption.IMPROVING_SLEEP]: { defaultMessage: "Improving sleep" },
  [HelpfulOption.URINARY_FREQUENCY_URGENCY]: { defaultMessage: "Urinary frequency and urgency" },
  [HelpfulOption.BONE_HEART_HEALTH]: { defaultMessage: "Bone or heart health" },
  [HelpfulOption.ORAL_HEALTH]: { defaultMessage: "Oral health" },
  [HelpfulOption.LOW_TESTOSTERONE]: { defaultMessage: "Low testosterone" },
  [HelpfulOption.WEIGHT_LOSS_MEDS_FERTILITY]: { defaultMessage: "Weight loss medication and fertility" },
  [HelpfulOption.WEIGHT_LOSS_MEDS_MENOPAUSE]: { defaultMessage: "Weight loss medication and menopause" },
  [HelpfulOption.SUPPLEMENTS_ALTERNATIVE_MEDS]: { defaultMessage: "Supplements and alternative medicine" },
  [HelpfulOption.SPERM_PRESERVATION]: { defaultMessage: "Sperm preservation" },
  [HelpfulOption.EGG_PRESERVATION]: { defaultMessage: "Egg preservation" },
  [HelpfulOption.BASELINE_FERTILITY_TESTING]: { defaultMessage: "Baseline fertility testing" },
  [HelpfulOption.PRESERVATION_BEFORE_MEDICAL_PROCEDURE]: {
    defaultMessage: "Preservation before a medical procedure"
  },
  [HelpfulOption.PRESERVATION_PROCESS]: { defaultMessage: "Preservation process" },
  [HelpfulOption.PREPARING_FOR_SPERM_PRESERVATION]: { defaultMessage: "Preparing for sperm preservation" },
  [HelpfulOption.PREPARING_FOR_EGG_PRESERVATION]: { defaultMessage: "Preparing for egg preservation" },
  [HelpfulOption.PREIMPLANTATION_GENETIC_TESTING]: { defaultMessage: "Preimplantation genetic testing (PGT)" },
  [HelpfulOption.PREPARING_FOR_SPERM_RETRIEVAL]: { defaultMessage: "Preparing for sperm retrieval" },
  [HelpfulOption.OPTIONS_FOR_SEMEN_COLLECTION]: { defaultMessage: "Options for semen collection" },
  [HelpfulOption.CRYOBANK_CRYOSHIPPING_INFO]: { defaultMessage: "Cryobank or cryoshipping information" },
  [HelpfulOption.INJECTION_GUIDANCE]: { defaultMessage: "Injection guidance" },
  [HelpfulOption.PREPARING_FOR_EGG_RETRIEVAL]: { defaultMessage: "Preparing for egg retrieval" },
  [HelpfulOption.TALK_ADOPTION_EXPERT]: { defaultMessage: "Talking to an adoption expert" },
  [HelpfulOption.FIND_ADOPTION_AGENCY]: { defaultMessage: "Finding an adoption agency or attorney" },
  [HelpfulOption.DOMESTIC_ADOPTION]: { defaultMessage: "Domestic adoption" },
  [HelpfulOption.INTERNATIONAL_ADOPTION]: { defaultMessage: "Intercountry/international adoption" },
  [HelpfulOption.FOSTER_CARE_ADOPTION]: { defaultMessage: "Foster care adoption" },
  [HelpfulOption.ADOPTION_PROCESS_STEPS]: { defaultMessage: "Steps in the adoption process" },
  [HelpfulOption.ADOPTION_JOURNEY_LENGTH]: { defaultMessage: "Average length of an adoption journey" },
  [HelpfulOption.ADOPTION_JOURNEY_COST]: { defaultMessage: "Average cost of an adoption journey" },
  [HelpfulOption.ADOPTION_PROVIDER_TYPES]: { defaultMessage: "Types of adoption providers" },
  [HelpfulOption.NEWBORN_ADOPTION]: { defaultMessage: "Newborn adoption" },
  [HelpfulOption.ADOPTION_LEGAL_CONSIDERATIONS]: { defaultMessage: "Legal considerations" },
  [HelpfulOption.ADOPTION_BASICS]: { defaultMessage: "Adoption basics" },
  [HelpfulOption.ADOPTION_AGENCY_QUESTIONS]: { defaultMessage: "Questions to ask an adoption agency" },
  [HelpfulOption.ADOPTION_ATTORNEY_QUESTIONS]: { defaultMessage: "Questions to ask an adoption attorney" },
  [HelpfulOption.ADOPTION_MATCHING_PROCESS]: { defaultMessage: "Matching process" },
  [HelpfulOption.ADOPTIVE_PARENT_PROFILE]: { defaultMessage: "Creating an adoptive parent profile" },
  [HelpfulOption.ADOPTION_BIRTH_PLANNING]: { defaultMessage: "Newborn adoption: birth planning considerations" },
  [HelpfulOption.ADOPTION_LEGAL_FINALIZATION]: { defaultMessage: "Legal finalization" },
  [HelpfulOption.POST_ADOPTION_EMOTIONS]: { defaultMessage: "Post-adoption emotions" },
  [HelpfulOption.PARENTING_AFTER_ADOPTION]: { defaultMessage: "Parenting after adoption" },
  [HelpfulOption.POST_PLACEMENT_SUPERVISION]: { defaultMessage: "Post-placement supervision" },
  [HelpfulOption.CARING_FOR_NEWBORN]: { defaultMessage: "Caring for a newborn" },
  [HelpfulOption.CARING_FOR_CHILD]: { defaultMessage: "Caring for a child" },
  [HelpfulOption.TALKING_ABOUT_ADOPTION]: { defaultMessage: "Talking about adoption" },
  [HelpfulOption.ADOPTION_FUTURE_PLANNING]: { defaultMessage: "Preparing for the future" },
  [HelpfulOption.EXPLORING_DIFFERENT_PATHS_TO_PARENTHOOD]: {
    defaultMessage: "Exploring different paths to parenthood"
  },
  [HelpfulOption.CONTRACEPTION_OPTIONS]: { defaultMessage: "Contraception options" },
  [HelpfulOption.FERTILITY_TESTING]: { defaultMessage: "Fertility testing" },
  [HelpfulOption.IMPROVING_FERTILITY_HEALTH]: { defaultMessage: "Improving fertility health" },
  [HelpfulOption.IRREGULAR_CYCLES]: { defaultMessage: "Irregular cycles" },
  [HelpfulOption.PREPARING_FOR_PREGNANCY]: { defaultMessage: "Preparing for pregnancy" },
  [HelpfulOption.ADOPTION]: { defaultMessage: "Adoption" },
  [HelpfulOption.GESTATIONAL_SURROGACY]: { defaultMessage: "Gestational surrogacy" },
  [HelpfulOption.GESTATIONAL_SURROGACY_STEPS]: { defaultMessage: "Steps in the gestational surrogacy process" },
  [HelpfulOption.ASSISTED_REPRODUCTION_SUPPORT]: { defaultMessage: "Assisted reproduction support" },
  [HelpfulOption.GESTATIONAL_SURROGACY_LEGAL_CONSIDERATIONS]: {
    defaultMessage: "Legal considerations"
  },
  [HelpfulOption.BENEFITS_WORKING_WITH_AGENCY]: { defaultMessage: "Benefits of working with an agency" },
  [HelpfulOption.HOW_CHOOSE_GESTATIONAL_SURROGACY_AGENCY]: {
    defaultMessage: "How to choose a gestational surrogacy agency"
  },
  [HelpfulOption.GESTATIONAL_SURROGACY_WITHOUT_AGENCY]: {
    defaultMessage: "Gestational surrogacy without an agency"
  },
  [HelpfulOption.GESTATIONAL_CARRIER_MATCHING_PROCESS]: {
    defaultMessage: "Gestational carrier matching process"
  },
  [HelpfulOption.CREATING_INTENDED_PARENT_PROFILE]: {
    defaultMessage: "Creating an intended parent profile"
  },
  [HelpfulOption.BIRTH_PLANNING_PREP_INTENDED_PARENTS]: {
    defaultMessage: "Birth planning and preparation for intended parent(s)"
  },
  [HelpfulOption.FETAL_DEVELOPMENT_PRENATAL_CARE]: {
    defaultMessage: "Fetal development and prenatal care"
  },
  [HelpfulOption.POST_BIRTH_EMOTIONS_MENTAL_HEALTH]: {
    defaultMessage: "Post-birth emotions and mental health"
  },
  [HelpfulOption.NEWBORN_CARE]: { defaultMessage: "Newborn care" },
  [HelpfulOption.FETAL_DEVELOPMENT_STAGES]: { defaultMessage: "Fetal development stages" },
  [HelpfulOption.HIGH_RISK_PREGNANCY_MULTIPLE_FETUSES]: {
    defaultMessage: "High-risk pregnancy or multiple fetuses"
  },
  [HelpfulOption.TRAVEL_CONSIDERATIONS]: { defaultMessage: "Travel considerations" },
  [HelpfulOption.PRENATAL_EDUCATION_PARENTING_CLASSES]: {
    defaultMessage: "Prenatal education and parenting classes"
  },
  [HelpfulOption.LOW_TESTOSTERONE_SYMPTOMS]: { defaultMessage: "Low testosterone symptoms" },
  [HelpfulOption.LOW_TESTOSTERONE_TREATMENT_OPTIONS]: { defaultMessage: "Low testosterone treatment options" },
  [HelpfulOption.COPING_WITH_SYMPTOMS]: { defaultMessage: "Coping with symptoms" },
  [HelpfulOption.SLEEP_APNEA_SLEEP_ISSUES]: { defaultMessage: "Sleep apnea and other sleep issues" },
  [HelpfulOption.CARDIOVASCULAR_HEALTH]: { defaultMessage: "Cardiovascular health" },
  [HelpfulOption.LOW_TESTOSTERONE_PERI_MENOPAUSE]: { defaultMessage: "Low testosterone as part of (peri)menopause" },
  [HelpfulOption.MEDICAL_OR_HEALTH_RELATED_QUESTIONS]: {
    defaultMessage: "Medical or health-related questions"
  },
  [HelpfulOption.GENDER_EXPLORATION_EMBODIMENT]: { defaultMessage: "Gender exploration and embodiment" },
  [HelpfulOption.FEMINIZING_HORMONE_THERAPY]: { defaultMessage: "Feminizing hormone therapy" },
  [HelpfulOption.MASCULINIZING_HORMONE_THERAPY]: { defaultMessage: "Masculinizing hormone therapy" },
  [HelpfulOption.SOCIAL_AFFIRMATION]: { defaultMessage: "Social affirmation" },
  [HelpfulOption.MEDICAL_AFFIRMATION]: { defaultMessage: "Medical affirmation" },
  [HelpfulOption.LEGAL_AFFIRMATION]: { defaultMessage: "Legal affirmation" },
  [HelpfulOption.BINDERS_AND_TUCKING_GARMENTS]: { defaultMessage: "Binders and tucking garments" },
  [HelpfulOption.VOICE_THERAPY]: { defaultMessage: "Voice therapy" },
  [HelpfulOption.HAIR_REMOVAL]: { defaultMessage: "Hair removal" },
  [HelpfulOption.NON_HORMONAL_GENDER_AFFIRMING_CARE_OPTIONS]: {
    defaultMessage: "Non-hormonal gender-affirming care options"
  },
  [HelpfulOption.OTHER_FERTILITY_QUESTIONS]: {
    defaultMessage: "Other fertility questions"
  },
  [HelpfulOption.HELP_FINDING_OBSTETRIC_PROVIDER]: {
    defaultMessage: "Help finding or choosing an obstetric provider"
  },
  [HelpfulOption.HELP_FINDING_DOULA]: { defaultMessage: "Help finding or choosing a doula" },
  [HelpfulOption.HELP_FINDING_PEDIATRICIAN]: { defaultMessage: "Help finding or choosing a pediatrician" },
  [HelpfulOption.PEDIATRIC_TELEMEDICINE]: { defaultMessage: "Pediatric telemedicine" },
  [HelpfulOption.PELVIC_FLOOR_THERAPY]: { defaultMessage: "Pelvic floor therapy" },
  [HelpfulOption.PELVIC_FLOOR_HEALTH]: { defaultMessage: "Optimizing pelvic floor health" },
  [HelpfulOption.PELVIC_FLOOR_DYSFUNCTION]: { defaultMessage: "Pelvic floor dysfunction" },
  [HelpfulOption.PELVIC_PAIN]: { defaultMessage: "Pelvic pain" },
  [HelpfulOption.URINARY_INCONTINENCE]: { defaultMessage: "Urinary incontinence" },
  [HelpfulOption.RECTAL_DISORDERS]: { defaultMessage: "Rectal disorders" },
  [HelpfulOption.ORGAN_PROLAPSE]: { defaultMessage: "Organ prolapse" },
  [HelpfulOption.ERECTILE_FUNCTION]: { defaultMessage: "Erectile function" },

  // start: deprecated WWBMH options
  [HelpfulOption.DISCUSS_OPTIONS]: { defaultMessage: "Discuss my options and journey" },
  [HelpfulOption.HELP_PATHWAY]: { defaultMessage: "Help with pathways or regulations" },
  [HelpfulOption.CHAT_LIFESTYLE]: { defaultMessage: "Learn about nutrition and lifestyle" },
  [HelpfulOption.DOULA_BIRTH_INFO]: { defaultMessage: "Information about birth doulas" },
  [HelpfulOption.HELP_NICU]: { defaultMessage: "Help navigating the NICU experience" },
  [HelpfulOption.HIGH_RISK_PREGNANCY_INFO]: { defaultMessage: "Information about high-risk pregnancy" },
  [HelpfulOption.LEARN_PARENT_NUTRITION_LIFESTYLE]: {
    defaultMessage: "Learn about parents' nutrition and lifestyle"
  },
  [HelpfulOption.UNDERSTAND_MILESTONES_NEURODIVERGENCE]: {
    defaultMessage: "Understand key developmental milestones and neurodivergence"
  },
  [HelpfulOption.HELP_CHILD_NUTRITION_EXERCISE]: { defaultMessage: "Help with children's nutrition and exercise" },
  [HelpfulOption.LEARN_CHILD_EMOTIONAL_WELL_BEING]: { defaultMessage: "Learn about children's emotional well-being" },
  [HelpfulOption.BENEFIT_ADVICE]: { defaultMessage: "Advice on making the most of my benefit" },
  [HelpfulOption.LEARN_PUBERTY]: { defaultMessage: "Learn about puberty" },
  [HelpfulOption.POSITIVE_PARENTING_TIPS]: { defaultMessage: "Positive parenting tips" },
  [HelpfulOption.HELP_SLEEP_ISSUES]: { defaultMessage: "Help with sleep issues" },
  [HelpfulOption.HELP_INFANT_FEEDING]: { defaultMessage: "Help with newborn/infant feeding" },
  [HelpfulOption.HELP_INFANT_SLEEP]: { defaultMessage: "Help with newborn/infant sleep" },
  [HelpfulOption.SUPPORT_WORK_RETURN]: { defaultMessage: "Help returning to work" },
  [HelpfulOption.LEARN_FIRST_TRIMESTER]: {
    defaultMessage: "Learn about 1st trimester fetal development and medical care"
  },
  [HelpfulOption.LEARN_SECOND_TRIMESTER]: {
    defaultMessage: "Learn about 2nd trimester fetal development and medical care"
  },
  [HelpfulOption.LEARN_THIRD_TRIMESTER]: {
    defaultMessage: "Learn about 3rd trimester fetal development and medical care"
  },
  [HelpfulOption.HELP_CHOOSE_BIRTH_LOCATION_PROVIDERS]: {
    defaultMessage: "Help choosing a birth location and providers"
  },
  [HelpfulOption.HELP_BIRTH_PLANNING]: {
    defaultMessage: "Help with birth planning, including choosing a location and providers"
  },
  [HelpfulOption.HELP_PREP_LABOR_DELIVERY]: { defaultMessage: "Help preparing for labor and delivery" },
  [HelpfulOption.LEARN_LACTATION]: { defaultMessage: "Learn about lactation" },
  [HelpfulOption.NAVIGATING_DIVORCE_CO_PARENTING]: { defaultMessage: "Navigating divorce and co-parenting" }

  // end: deprecated WWBMH options
}

function getMostHelpfulOptionTitles(): OptionTitle[] {
  return Object.entries(mostHelpfulOptions).map(([id, { defaultMessage }]) => ({
    id,
    title: defaultMessage
  }))
}

export const MostHelpfulOptions: Array<OptionTitle> = getMostHelpfulOptionTitles()
